module.exports = __webpack_public_path__ + "img/tissu-choisit-img9.18d5be89.jpg";